// Utilities
//
// Project-wide utility functions

export {
    mergeExistingKeys,
    getLines,
    clamp,
    remap,
    pxToVW,
    degToRad,
}

function mergeExistingKeys(source, dest) {
    // Overwrite destination object values for keys that exists in the source object
    Object.getOwnPropertyNames(dest).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            dest[key] = source[key];
        }
    });
}

// Extract lines from a long string at word breaks before given length param
// Return an array of trimmed lines
function getLines(str, length) {
    const lines = [];
    if (str.length <= length) {
        lines.push(str);
    } else {
        let s = str;

        while (s.length > 0) {
            let line;
            if (s.length > length) {
                line = s.slice(0, s.slice(0, length).lastIndexOf(' '));
            } else {
                line = s;
            }
            if (line.length > 0) {
                s = s.slice(line.length);
                lines.push(line.trim());
            } else {
                s = '';
            }
        }
    }
    return lines;
}

function clamp (value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}

function constrain(n, low, high) {
    return Math.max(Math.min(n, high), low);
  }

let newval;
function remap(n, start1, stop1, start2, stop2, withinBounds) {
  newval = ((n - start1) / (stop1 - start1)) * (stop2 - start2) + start2;
  if (!withinBounds) {
    return newval;
  }
  if (start2 < stop2) return constrain(newval, start2, stop2);
  return constrain(newval, stop2, start2);
}
function pxToVW(val) {
    return val * (100/1920) + 'vw';
}
function degToRad(deg) {
    return deg * Math.PI / 180;
}